import React, { ReactNode } from 'react'

import cn from 'classnames'

import styles from './CardHeader.module.scss'

type CardHeaderProps = {
  children?: ReactNode
  className?: string
  center?: boolean
  addSpacing?: boolean
}

export const CardHeader = ({
  children,
  className,
  center,
  addSpacing,
}: CardHeaderProps) => {
  return (
    <div
      className={cn(
        styles.root,
        center && styles.center,
        addSpacing && styles.addSpacing,
        className
      )}
    >
      {children}
    </div>
  )
}

export default CardHeader
